import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { RootState } from "../../../init/reduxInit";
import { widgetSlice } from "./slice";
import { useMemo } from "react";

// Create selectors
const selectWidgetLoading = (state: RootState) => state.widget.loading;
const selectWidgetState = (state: RootState) => state.widget.state;

export const useWidget = () => {
    const dispatch = useDispatch();

    // Use specific selectors instead of selecting the entire state
    const loading = useSelector(selectWidgetLoading);
    const state = useSelector(selectWidgetState);

    // Memoize actions and thunks
    const actions = useMemo(
        () => bindActionCreators(widgetSlice.actions, dispatch),
        [dispatch]
    );

    return {
        loading,
        state,
        actions,
    };
};
